import { Message } from "element-ui";
import router from "./router";
import store from "./store";

import { queryDataboard } from "./models/dataReportmodel";
const whiteList = ["/login"];
function initLoginStatus() {
  store.dispatch("user/clearRoles");
  store.dispatch("user/resetToken");
  store.dispatch("app/clearInterval");
  store.dispatch("permission/clearRoute", "");
  store.dispatch("platform/clearInterval");
  store.dispatch("platform/switchPlatformOrderMessageShow", false);
  // resetRouter()
}

router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem("token");
  if (token) {
    if (to.path === "/login") {
      // 重新跳转登陆清除路由 清除循环请求
      next();
      initLoginStatus();
    } else {
      // 已经登录
      if (store.getters.roles && store.getters.roles.length > 0) {
        next();
      } else {
        // 首次登录或刷新
        // 获取权限
        try {
          const roles = await store.dispatch("user/getRoles");

          // 获取待处理工单
          const dashboardData = await queryDataboard({
            shop_id: localStorage.getItem("shop_id")
          });
          if (dashboardData && dashboardData.as_order_wo_num) {
            const { as_order_wo_num } = dashboardData;
            const total =
              Number(as_order_wo_num.mc_ycl) +
              Number(as_order_wo_num.mh_new) +
              Number(as_order_wo_num.mh_back);
            store.dispatch("permission/setDashboardData", total);
          }

          const accessRoutes = await store.dispatch(
            "permission/generateRoutes",
            roles
          );
          if (accessRoutes.length > 0) {
            router.addRoutes(accessRoutes);
            if (localStorage.getItem("shop_type") == "0") {
              store.dispatch("platform/getNoArrivedOrder", {
                orderCount: 0,
                asOrderCount: 0,
                show: false
              });
            }
            let path = localStorage.getItem("menuActive");
            if (path) {
              next(path);
            } else {
              if (localStorage.getItem("is_jgj") === "1") {
                // 为紧固件的时候
                next("/order/manageFastener");
              } else {
                next("/dataReport/echart");
              }
            }
          } else {
            next(`/login`);
          }
          console.log("roles:", roles);
          console.log(
            roles && !roles.includes("r4gys"),
            "roles && !roles.includes('r4gys')"
          );
          if (roles && !roles.includes("r4gys")) {
            // 包含r4供应商
            store.dispatch("user/getJzbInfo");
            console.log(898989);
          }
        } catch (error) {
          // remove token and go to login page to re-login
          Message.error(error || "Has Error");
          next(`/login`);
          initLoginStatus();
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login`);
    }
    initLoginStatus();
  }
});



// WEBPACK FOOTER //
// ./src/permission.js